import './email-preview.css'

const isFullDocument = (html: string) =>
  /^\s*<!doctype html/i.test(html) || /^\s*<html[\s>]/i.test(html)

function frameDocument(html: string): string {
  if (isFullDocument(html)) return html
  /* Literal colors belong to the sandboxed email document: it inherits no app
     tokens, and its white page keeps the received message legible in dark mode. */
  return `<!doctype html><html><head><meta charset="utf-8">
<style>
  body { margin: 0; padding: 16px; background: #fff; font-family: system-ui, -apple-system, sans-serif;
         font-size: 15px; line-height: 1.6; color: #1b1f27; }
  a { color: #8a6317; }
  p { margin: 0 0 12px; }
  h2, h3 { margin: 16px 0 8px; line-height: 1.3; }
</style></head><body>${html}</body></html>`
}

/**
 * Email HTML as its own inert document, exactly as a mail client receives it.
 * A complete server render is framed verbatim; only a bare fragment receives
 * the fallback shell used by locally composed messages.
 */
export function EmailPreview({
  html,
  subject,
  title = 'Message preview',
}: {
  html: string
  subject?: string | null
  title?: string
}) {
  return (
    <article className="email-preview">
      {subject ? <p className="email-preview__subject">{subject}</p> : null}
      <iframe
        className="email-preview__frame"
        title={title}
        sandbox=""
        srcDoc={frameDocument(html)}
      />
    </article>
  )
}
